import React from "react";
import { useParams } from "react-router-dom";
import "../../components/login/TelegramLogin.scss";
import LinkToApp from "../../components/LinkToApp";

export default function LinkToAppLeaderDiaryDetails({ subUrl }) {
  const { diaryId } = useParams();

  const subDir = diaryId ? `LeaderDiaryDetails/${diaryId}` : "";

  return <LinkToApp subDir={subDir} />;
}
